// document.addEventListener('DOMContentLoaded', function() {
//     // Function to initialize the Swiper
//     const initSwiper = () => {
//         const swiperContainer = document.createElement('div');
//         swiperContainer.className = 'swiper';
//         const swiperWrapper = document.createElement('div');
//         swiperWrapper.className = 'swiper-wrapper';
//         const mediaLinks = document.querySelectorAll('.jdgm-ugc-media__thumbnail-link');

//         const swiperScrollbar = document.createElement('div');
//         swiperScrollbar.className = 'swiper-scrollbar';
//         swiperContainer.appendChild(swiperWrapper);
//         swiperContainer.appendChild(swiperScrollbar);

//         mediaLinks.forEach(link => {
//             link.classList.add('swiper-slide'); // Add Swiper slide class to each link
//             swiperWrapper.appendChild(link); // Append link to Swiper wrapper
//         });
//         swiperContainer.appendChild(swiperWrapper);
//         const mediaContainer = document.querySelector('.jdgm-ugc-media');
//         if (mediaContainer) {
//             mediaContainer.parentNode.replaceChild(swiperContainer, mediaContainer);
//         }

//         new Swiper('.jdgm-ugc-media-wrapper .swiper', {
//              slidesPerView: 1.8,
//       spaceBetween: 15,
//       direction: "horizontal",
//       loop: false,
//       freeMode: true,
//       breakpoints: {
//         1920: {
//           slidesPerView: 4.5,
//           spaceBetween: 15
//         },
//         992: {
//           slidesPerView: 4.5,
//           spaceBetween: 15
//         },
//         767: {
//            slidesPerView: 2.5,
// 		       spaceBetween: 15
//         }
//       },
      
//       scrollbar: {
//         el: ".jdgm-ugc-media-wrapper .swiper-scrollbar",
//         draggable: true
//      }
//         });
//     };

//     // Setting up MutationObserver
//     const observer = new MutationObserver((mutations, obs) => {
//         const mediaLinks = document.querySelectorAll('.jdgm-ugc-media__thumbnail-link');
//         if (mediaLinks.length > 0) {
//             initSwiper();  // Initialize Swiper when links are detected
//             obs.disconnect(); // Stop observing after initialization
//         }
//     });

//     // Configuration for the observer (which mutations to observe)
//     const config = { childList: true, subtree: true };

//     // Start observing the document
//     observer.observe(document.body, config);
// });

// $(document).ready(function() {

//     const initSlickSlider = () => {        
//         // Add div before and after the elements correctly
//            var sliderDiv = $('<div class="slick-slider_ugc"></div>');
//     $('.jdgm-ugc-media__thumbnail-link:first').before(sliderDiv);
//     $('.jdgm-ugc-media__thumbnail-link').appendTo('.slick-slider_ugc');
        
//         // Initialize Slick on the newly added divs
//         $(".jdgm-ugc-media .slick-slider_ugc").slick({
//             slidesToShow: 3,
//             infinite: false,
//             slidesToScroll: 1,
//             autoplay: false,
//             autoplaySpeed: 2000
//         });
//     };

//     // Use MutationObserver to wait for the elements to load
//     const observer = new MutationObserver((mutations, obs) => {
//         if ($('.jdgm-ugc-media__thumbnail-link').length) {
//             initSlickSlider(); 
//             obs.disconnect(); 
//         }
//     });

//     const config = { childList: true, subtree: true };
//     observer.observe(document.body, config);
// });


// jugeme review

screen.width < 1e3 &&
  ($(
    "html[lang=en] .custom_product_page .product-gallery__image-list.product-gallery__image-list_data scroll-carousel"
  ).slick({
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: !0,
          dots: !0,
        },
      },
    ],
  }),
  $(
    "html[lang=ar] .custom_product_page .product-gallery__image-list.product-gallery__image-list_data scroll-carousel"
  ).slick({
    responsive: [
      {
        breakpoint: 991,
        settings: {
          arrows: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: !0,
          dots: !0,
          rtl: !0,
        },
      },
    ],
  }));
var strapCheckedAmount = 0;
$(".secondStrap").on("click", function () {
  var t = $(".secondStrap").length / 3,
    a = $(".addSecondStrapContainerTitle"),
    e = $(".secondStrapAddedProductTitle"),
    i = $(this).data("index"),
    s = $(this).find(".stf"),
    o = $(this).find(".secondStrapPrice span.money"),
    r = $(this).find(".strapCheckboxWrapper .strapCheckbox  span.added"),
    c = $(".regular-price_val .money").text().split(" ")[0],
    l = $(this).find(".tpProductSelect"),
    n = $(".regular-price_val .money")
      .text()
      .replace(/[^\d\.]/g, ""),
    d = $(".regular-price_val .money").text(),
    p = $(this).find("span.money").attr("doubly-currency-aed"),
    p = $(this).find(".secondStrapPrice").find("span.money").text(),
    u = parseFloat(0),
    h = parseFloat(0),
    v = d.charAt(0),
    m = parseFloat(d.replace(/[^\d\.]/g, "")),
    f = parseFloat(p.replace(/[^\d\.]/g, ""));
  p = void 0 == p ? 0 : p;
  var g = parseFloat(f),
    y = parseFloat(n.toString().replace(",", ""));
  h += y;
  var k = parseFloat(f),
    b = parseFloat(n);
  if (((u += b), $(this).hasClass("strapActive"))) {
    strapCheckedAmount--, $(this).removeClass("strapActive");
    var C = $(this).find(".tpProductSelect").val();
    $(this).parents("li.item").attr("data_variant_id", "");
    for (
      var w = $('[data-block-type = "buy-buttons"] .shopify-product-form').find(
          ".product_id input"
        ),
        x = 0;
      x < w.length;
      x++
    )
      console.log(w[x]), w[x].value == C && w[x].remove();
    o.show(),
      r.text(""),
      e.find("span[data-index=" + i + "]").remove(),
      l.prop("checked", !1),
      (u -= k);
    var A = parseFloat(m) - parseFloat(f);
    let S = "";
    (S = v.replace(/[^0-9]/g, "") ? A.toFixed(2) + " د.إ" : v + A.toFixed(2)),
      $(".price-list").find(".regular-price_val .money").empty().text(S),
      (h -= g),
      u.toFixed(2),
      $(".fixedBarprice").html(S);
  } else {
    strapCheckedAmount++, $(this).addClass("strapActive");
    var C = $(this).find(".tpProductSelect").val();
    $(this).parents("li.item").attr("data_variant_id", C);
    var _ =
      '<input type="hidden" name="id" value="' +
      $(this).find(".tpProductSelect").val() +
      '">';
    $('[data-block-type = "buy-buttons"] .shopify-product-form')
      .find(".product_id")
      .append(_),
      r.text("Added"),
      e.append('<span data-index="' + i + '">' + s.text() + "</span>"),
      l.prop("checked", !0),
      (u += k);
    var A = parseFloat(m) + parseFloat(f);
    let I = "";
    v.replace(/[^0-9]/g, "")
      ? (I = A.toFixed(2) + " د.إ")
      : ((I = v + " " + A.toFixed(2)), console.log("after", c)),
      $(".price-list").find(".regular-price_val .money").empty().text(I),
      (h += g),
      u.toFixed(2),
      $(".fixedBarprice").html(I);
  }
  0 == strapCheckedAmount
    ? a.show().find("span").text("A Second")
    : t == strapCheckedAmount
    ? a.show().find("span").text("A Third")
    : 1 == strapCheckedAmount
    ? a.show().find("span").text("A Third")
    : 2 == strapCheckedAmount
    ? a.show().find("span").text("A Fourth")
    : 3 == strapCheckedAmount
    ? a.show().find("span").text("A Fifth")
    : 4 == strapCheckedAmount
    ? a.hide()
    : 5 == strapCheckedAmount
    ? a.hide()
    : a.show().find("span").text("Another");
}),
// $(document).on("click", '.v-stack .buy-buttons .button', function () {
    // var t = [];
    // var gift_wrap = $('.comp_checkbox.gift_che .box_gift.gift_check input[type="checkbox"]:checked').val();
    // var gift_prop = $('.comp_checkbox.gift_che #gift_box').val();
    // var cart_note = $('.comp_checkbox_wrap.gift_che_add .gift_note_pro').val();
    // $('[data-block-type="buy-buttons"] .shopify-product-form input[name="id"]').each(function () {
    //     var a = $(this).val();
    //     t.push({
    //         quantity: 1,
    //         id: a,
    //         properties: {
    //             "Gift Wrapping": gift_wrap,
    //             "Gift Wrapping Type": gift_prop,
    //             "Gift Note": cart_note
    //         }
    //     });
    // });
    
    // var formData = { 'items': t };
    
    // $.ajax({
    //     url: "/cart/add.js",
    //     type: "POST",
    //     dataType: "json",
    //     data: formData,
    //     success: function (response) {
    //         console.log('response', response);
    //         // Refresh the cart using Shopify's AJAX API
    //         $.ajax({
    //             url: "/cart",
    //             type: "GET",
    //             dataType: "html",
    //             success: function (cartHtml) {
    //                 // Update cart drawer with the updated HTML
    //                 $('#cart-drawer').html($(cartHtml).find('#cart-drawer').html());
                    
    //                 // Update header cart count
    //                 var cartCount = $(cartHtml).find('.header .cart_drawer_ou .cart_count').text();
    //                 $('.header .cart_drawer_ou .cart_count').text(cartCount);
    //             },
    //             error: function (xhr, status, error) {
    //                 console.error("AJAX request failed:", status, error);
    //             }
    //         });
    //     },
    //     error: function (xhr, status, error) {
    //         console.error("AJAX request failed:", status, error);
    //     }
    // });
// }),
  $(".variant-picker__option .sr-only").on("change", function () {
    $(this);
    var t, a = $(this).attr("data_va_id").trim().replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, ""),
      e = $(this).parents(".custom_product_page").find(".product-gallery_new product-gallery-navigation button"),
      i = $(this).parents(".custom_product_page").find(".product-gallery__image-list_data scroll-carousel .product-gallery__media");
    for (
      $(e).each(function () {
        ($(this).hasClass("active_img") || $(this).hasClass("dactive_img")) &&
          ($(this).removeClass("dactive_img"),
          $(this).removeClass("active_img"));
      }),
        $(i).each(function () {
          ($(this).hasClass("active_img") || $(this).hasClass("dactive_img")) &&
            ($(this).removeClass("dactive_img"),
            $(this).removeClass("active_img"));
        }),
        t = 0;
      t < e.length;
      t++
    ) {
      var s = e[t].attributes.data_var_id.value.replace(
        /[&\/\\#, +()$~%.'":*?<>{}_-]/g,
        ""
      );
      a === s
        ? e[t].classList.add("active_img")
        : e[t].classList.add("dactive_img");
    }
    for (t = 0; t < i.length; t++) {
      var s = i[t].attributes.data_var_id1.value.replace(
        /[&\/\\#, +()$~%.'":*?<>{}_-]/g,
        ""
      );
      a === s
        ? i[t].classList.add("active_img")
        : i[t].classList.add("dactive_img");
    }
    $(".custom-overlay").css("display", "none"),
      $(".custom-popup").removeClass("right0"),
      $("html").css("overflow-y", "scroll");
  });
var val_ch_data = $(".custom_product_page").find(
  ".product-gallery_new product-gallery-navigation button"
);
$(val_ch_data).on("click", function () {
  var t = $(
    ".custom_product_page .product-gallery__image-list_data scroll-carousel .product-gallery__media"
  );
  $(t).each(function () {
    $(this).hasClass("dactive_img") &&
      ($(this).removeClass("dactive_img"), $(this).removeClass("active_img"));
  });
}),
  $("safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button").on("click", function () {
    // debugger;
    var t = $(this).attr("data-media-id");
    $(".product-gallery__image-list_data scroll-carousel .product-gallery__media").removeClass("image_display_none  , image_display"),
    $(".product-gallery__image-list_data scroll-carousel figure.prod_img").removeClass("img_show"),
      $(".product-gallery__image-list_data scroll-carousel .product-gallery__media").each(function () {
        var a = $(this);
        $(this).attr("data-media-id") == t ? a.addClass("image_display") : a.addClass("image_display_none");
         $(this).attr("data-media-id") == t ? $(this).parents('figure.prod_img').addClass("img_show") : $(this).parents('figure.prod_img').removeClass("img_show");
      });
  }),
  // $(".gift_note_pro").val(""),
  // $(".comp_label").click(function () {
  //   $(".comp_checkbox .comp_label input").is(":checked")
  //     ? $(".gift_note_pro").slideDown()
  //     : ($(".gift_note_pro").slideUp(), $(".gift_note_pro").val(""));
  // }),
  // $(".comp_label").click(function () {
  //   $(".comp_checkbox .comp_label input").is(":checked")
  //     ? $(".comp_label .checkmark").removeClass("remove_check")
  //     : $(".comp_label .checkmark").addClass("remove_check"),
  //     $(".gift_note_pro").val().length < 0 ||
  //       $(".gift_note_pro").removeAttr("name", "properties[Cart Note]");
  // }),
  $(document).on("click", ".cart-drawer__items .close-cart", function () {
    $(this)
      .parents(".Cart__ItemList ")
      .find("#cart_popup_val")
      .css("display", "block");
  }),
  $(document).on("click", ".cancel_cart  #new_ps_close", function () {
    $(this)
      .parents(".Cart__ItemList ")
      .find("#cart_popup_val")
      .css("display", "none");
  }),
  $(document).on("click", ".delete_cart  .CartItem__Remove ", function () {
    $(this)
      .parents(".Cart__ItemList ")
      .find("#cart_popup_val")
      .css("display", "none");
    var t = $(this)
        .parents("line-item")
        .find("price-list .money")
        .text()
        .replace(/[^\d\.]/g, ""),
      a = $(".cart-drawer__footer .cart-drawer__button-price .money")
        .text()
        .replace(/[^\d\.]/g, ""),
      e = Number(a) - Number(t);
    $(".cart-drawer__footer .cart-drawer__button-price .money")
      .empty()
      .append(e.toFixed(2)),
      $(this)
        .parents(".Cart__ItemList")
        .find(".add_match_accessories_val")
        .css("display", "none"),
      $(this).parents("line-item").remove();
    var i = 0;
    $("quantity-selector")
      .find(".quantity-selector__input")
      .each(function () {
        i = Number(i) + Number($(this).val());
      }),
      $("header .cart_drawer_ou").find(".Header__CartCount").empty().append(i),
      $(".cart-drawer__items").find(".line-item").length <= 0
        ? ($("cart-drawer .empty_class").css("display", "block"),
          $("cart-drawer .cart-drawer__footer").css("display", "none"),
          $("cart-drawer .cart-drawer__items").css("display", "none"))
        : ($("cart-drawer .empty_class").css("display", "none"),
          $("cart-drawer .cart-drawer__footer").css("display", "block"),
          $("cart-drawer .cart-drawer__items").css("display", "block"));
  }),
  $(".search_header_val .modal-header svg").on("click", function () {
    $("header-search.header-search").css("display", "none"),
      $("header-search.header-search").removeAttr("open"),
      $("html").removeClass("lock"),
      $(".search_click").attr("aria-expanded", "false");
  }),
  $(document).ready(function () {
    $('.shopify-section--shop-the-look button[type="button"]').on(
      "click",
      function () {
        $(
          "shop-the-look-desktop-carousel.shop-the-look__carousel .shop-the-look__item"
        ).each(function () {
          console.log($(this).addClass("is-selected"));
        });
      }
    ),
      $(".header__primary-nav button").on("click", function () {
        $("header-sidebar .header-sidebar__main-panel").append(
          '<a href="#" class="account_popup" style="font-size: 12px; text-decoration: none; color: #000;">Login</a>'
        );
      }),
      $(document).on("click", ".account_popup", function () {
        $("html").removeClass("right_menu_overlay"),
          $("body").addClass("login_popup_overlay"),
          $(".login_popup_overlay #sidebar-menu").css("display", "none"),
          $(".login_popup_overlay .header__primary-nav button").attr(
            "aria-expanded",
            "false"
          ),
          $(".login_popup_overlay .login_popup_model.modal").css(
            "display",
            "flex"
          ),
          $(".login_popup_overlay .login_popup_model.modal").addClass(
            "log_acc_popup"
          );
      }),
      $(".icofont-close-line").on("click", function () {
        $(".login_popup_model.modal").css("display", "none"),
          $("body").removeClass("login_popup_overlay");
      });
    var t = document.getElementById("myModal");
    (window.onclick = function (a) {
      a.target == t && (t.style.display = "none");
    }),
      $(".custom-flex").click(function () {
        $(this).find(".custom-overlay").css("display", "block"),
          $(this).find(".custom-popup").addClass("right0"),
          $("html").css("overflow-y", "hidden");
      }),
      $(document).on("click", ".custom-close", function () {
        $(".custom-overlay").css("display", "none"),
          $(this).parents(".custom-popup").removeClass("right0"),
          $("html").css("overflow-y", "scroll");
      }),
      $(document).on("click", ".custom-overlay", function () {
        $(this).css("display", "none"),
          $(this).next(".custom-popup").removeClass("right0"),
          $("html").css("overflow-y", "scroll");
      }),
      $(".sizeguard , .see-the-fit-btn").on("click", function () {
        $(".bs-example-modal-lg2").css("display", "block");
      }),
      $(".care-main-btn").on("click", function () {
        $(".bs-example-modal-care").css("display", "block");
      }),
      $(".modal .close-btn").on("click", function () {
        $(".bs-example-modal-lg2").css("display", "none");
        $(".bs-example-modal-care").css("display", "none");
      }),
      $("html[lang='en'] .custom-shipping-mobile-slider").slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: !0,
        autoplay: !0,
        autoplaySpeed: 0,
        speed: 6e3,
        pauseOnHover: !1,
        cssEase: "linear",
        responsive: [
          {
            breakpoint: 768,
            settings: { slidesToShow: 1.5, slidesToScroll: 1 },
          },
        ],
      }),
      $(".explr-serie-carousel").slick({
        slidesToShow: 4,
        slidesToScroll: 3,
        infinite: !0,
        dots: !1,
      }),
      // $("#upsel-checkbx").click(function () {
      //   $(this).is(":checked")
      //     ? $(".gift_note_pro").slideDown(500)
      //     : $(".gift_note_pro").slideUp(500);
      // }),
      $("ul.tabs li").click(function () {
        $(this).addClass("active"),
          $(this).siblings("ul.tabs li").removeClass("active");
        var t = $(this).attr("rel");
        $("." + t).addClass("active_content"),
          $("." + t)
            .siblings(".tab_content")
            .removeClass("active_content"),
          $(".tab_drawer_heading[rel^='" + t + "']").addClass("d_active"),
          $(".tab_drawer_heading[rel^='" + t + "']")
            .siblings(".tab_drawer_heading")
            .removeClass("d_active");
      }),
      $(".tab_drawer_heading").on("click", function () {
        $(this).hasClass("d_active")
          ? ($(this).next().slideUp("slow"),
            $(this).removeClass("d_active"),
            $(this).next().removeClass("active_content"))
          : $(this).toggleClass("d_active"),
          $(this).next().addClass("active_content"),
          $(this).next().css("display", "block");
      }),
      $(".galary-slides .li_st").click(function () {
        // debugger;
        var t = $(this).find("img").attr("src");
        $("#small-slider-zoom").html(" "),
          $("#small-slider-zoom").prepend(
            '<img id="mobile_zoom_effect" src="' + t + '" />'
          ),
          // $("#mobile_zoom_effect")
          //   .wrap('<span class="zoom" style="display:inline-block;"></span>')
          //   .css("display", "block")
          //   .parent(),
          $('#mobile_zoom_effect')
    .wrap('<span class="zoom" style="display:inline-block;"></span>')
    .css('display', 'block')
    .parent()
    .zoom({ on:'click',touch:'true', zoomWindowWidth:1200, zoomWindowHeight:1200});
          $(".model_img").css("display", "block");
      }),
      $(".close_popup").click(function () {
        $(".model_img").css("display", "none"),
          $("#small-slider-zoom").prepend(""),
          $("#small-slider-zoom").find("span").remove();
      }),
      $(".variant-picker__option-info").on("click", function () {
        var t = $(this)
            .next(".variant-picker__option-values")
            .attr("data_option_val"),
          a = $(this).attr("data_option_name");
        $("variant-option-value").text(),
          t === a
            ? ($(this)
                .next()
                .find(".custom-popup")
                .addClass("custom_popup_drop"),
              $(this).next().find(".custom-overlay").css("display", "block"))
            : $(this)
                .next()
                .find(".custom-popup")
                .removeClass("custom_popup_drop");
      }),
      $(".custom-close").on("click", function () {
        $(this)
          .parents(".variant-picker__option-values .custom-popup")
          .removeClass("custom_popup_drop");
      }),
      $(".custom-popup .swatch-products a.custom-popup-product label").on(
        "click",
        function () {
          $(".custom-popup").removeClass("custom_popup_drop");
        }
      ),
      $(".variant-picker__option-values .custom-overlay").on(
        "click",
        function () {
          $(this).css("display", "none"),
            $(".custom-popup").removeClass("custom_popup_drop");
        }
      ),
      $(
        ".variant-picker__option-values .custom-popup .custom-popup-product label"
      ).on("click", function () {
        var t = "",
          a = $(this).parents(".custom-popup").attr("name_of_var");
        $(
          ".product-gallery__image-list_data scroll-carousel .product-gallery__media"
        ).removeClass("image_display_none  , image_display");
        var e = $(this).prev().val();
        if (
          ($("variant-option-value").each(function () {
            var t = $(this).attr("class");
            a == t &&
              $("variant-option-value." + t)
                .empty()
                .append(e);
          }),
          $(this).hasClass("media-swatch"))
        ) {
          var i = $(this)
            .prev("input")
            .attr("value")
            .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, "");
          $(this)
            .parents(".swatch-products")
            .find(".custom-popup-product input")
            .removeAttr("checked"),
            $(this).prev("input").attr("checked", "checked");
          var s = $(this)
            .parents("variant-picker")
            .find(".swatch-products .custom-popup-product label.block-swatch")
            .prev("input:checked")
            .val();
          t += i + s;
        } else if ($(this).hasClass("block-swatch")) {
          var i = $(this)
            .prev("input")
            .attr("value")
            .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, "");
          $(this)
            .parents(".swatch-products")
            .find(".custom-popup-product input")
            .removeAttr("checked"),
            $(this).prev("input").attr("checked", "checked");
          var s = $(this)
            .parents("variant-picker")
            .find(".swatch-products .custom-popup-product label.media-swatch")
            .prev("input:checked")
            .val();
          t += s + i;
        }
        var o = t.replace(" ", "");
        $(
          "safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button"
        ),
          $("scroll-carousel .product-gallery__media"),
          $(
            "safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button"
          ).removeClass("active_img reactive_img"),
          $("scroll-carousel .product-gallery__media").removeClass(
            "active_img_bar reactive_img_bar"
          ),
          $("carousel-navigation button.tap-area").removeClass(
            "active_img_dots reactive_img_dots"
          ),
          $(
            "safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button"
          ).each(function () {
            var t = $(this);
            $(this).attr("data_var_id") == o
              ? t.addClass("active_img")
              : t.addClass("reactive_img");
          }),
          $(
            ".product-gallery__image-list_data scroll-carousel .product-gallery__media"
          ).each(function () {
            var t = $(this);
            $(this).attr("daat_var_val_di") == o
              ? t.addClass("active_img_bar")
              : t.addClass("reactive_img_bar");
          }),
          $("carousel-navigation button.tap-area").each(function () {
            var t = $(this);
            $(this).attr("var_data_meid") == o
              ? t.addClass("active_img_dots")
              : t.addClass("reactive_img_dots");
          }),
          $(".product_var_id input").each(function () {
            if ($(this).val().includes(o)) {
              let t = $(this).attr("data-id");
              $(".product .var_id_val1").empty().append(t);
            } else $(this);
          });
        var r = $(".product .var_id_val1").text();
        $(".product_custom .variant_id").removeClass(
          "active_details deactive_details"
        ),
          $(".product_custom .variant_id").each(function () {
            $(this).attr("var_id").includes(r)
              ? $(this).addClass("active_details")
              : $(this).addClass("deactive_details");
          });
        var c = "";
        $(".product_var_id").each(function () {
          $(this).find("input").attr("value") == o &&
            (c += $(this).find("input").attr("data-id"));
        }),
          $(".upsell_variant").removeClass("active_upsell deactive_upsell"),
          $(".upsell_variant").each(function () {
            $(this).attr("variant_upsell") == c
              ? $(this).addClass("active_upsell")
              : $(this).addClass("deactive_upsell");
          });
        var l = $(this)
          .attr("data_sel_val")
          .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, "");
        $(".product_var_id input").each(function () {
          if (
            $(this)
              .attr("var_name")
              .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, "") == l
          ) {
            var t = $(this).attr("data-id");
            $(
              '.product .product-info__block-item .shopify-product-form input[name="id"]'
            ).attr("value", t);
            var a = $(this).attr("var_avilabel");
            "false" == a
              ? $(
                  ".product .product-info__block-item .shopify-product-form buy-buttons button"
                )
                  .empty()
                  .text("Sold out")
              : "true" == a &&
                $(
                  ".product .product-info__block-item .shopify-product-form buy-buttons button"
                )
                  .empty()
                  .text("ADD TO Cart");
          } else $(this);
        }),
          $(".custom-overlay").css("display", "none");
      }),
      $(window).on("load", function () {
        let t = "";
        $(".variant-picker__option").each(function () {
          t += $(this)
            .find(
              ".variant-picker__option-values .custom-popup-product input:checked"
            )
            .val();
        });
        let a = t.replace(" ", "");
        var e = $(
          ".variant-picker__option-values .custom-popup-product label.media-swatch"
        )
          .prev("input:checked")
          .val();
        $(
          ".variant-picker__option-values .custom-popup label.block-swatch "
        ).removeClass("var_sel_stone var_desel_stone"),
          $(
            ".variant-picker__option-values .custom-popup label.block-swatch"
          ).each(function () {
            $(this).attr("default_active_sto") == e
              ? $(this).addClass("var_sel_stone")
              : $(this).addClass("var_desel_stone");
          }),
          $(
            ".product-gallery__image-list_data scroll-carousel .product-gallery__media"
          ).each(function () {
            var t = $(this);
            $(this).attr("daat_var_val_di") == a
              ? t.addClass("active_img_bar")
              : t.addClass("reactive_img_bar");
          }),
          $(
            "safe-sticky.product-gallery__thumbnail-list_new product-gallery-navigation button"
          ).each(function () {
            var t = $(this);
            $(this).attr("data_var_id") == a
              ? t.addClass("active_img")
              : t.addClass("reactive_img");
          }),
          $("carousel-navigation button.tap-area").each(function () {
            var t = $(this);
            $(this).attr("var_data_meid") == a
              ? t.addClass("active_img_dots")
              : t.addClass("reactive_img_dots");
          });
        var i = $(".product .var_id_val1").text();
        $(".product_custom .variant_id").removeClass(
          "active_details deactive_details"
        ),
          $(".product_custom .variant_id").each(function () {
            $(this).attr("var_id").includes(i)
              ? $(this).addClass("active_details")
              : $(this).addClass("deactive_details");
          }),
          $(".upsell_variant").removeClass("active_upsell deactive_upsell"),
          $(".upsell_variant").each(function () {
            $(this).attr("variant_upsell").includes(i)
              ? $(this).addClass("active_upsell")
              : $(this).addClass("deactive_upsell");
          });
      }),
      $(
        ".variant-picker__option-values .custom-popup .custom-popup-product label.media-swatch"
      ).on("click", function () {
        var t = $(this)
            .prev("input")
            .val()
            .replace(/[&\/\\#, +()$~%.'":*?<>{}_-]/g, ""),
          a = $(".product").find('.product_var_id input[type="hidden"]'),
          e = [],
          i = 0;
        $(a).each(function () {
          $(this).attr("vari_first") === t
            ? ($(this).attr("vari_secon"), (e[i++] = $(this).attr("var_name")))
            : $(this);
        }),
          $(
            ".variant-picker__option-values .custom-popup label.block-swatch "
          ).removeClass("var_sel_stone var_desel_stone");
        for (
          var s = $(
              ".variant-picker__option-values .custom-popup label.block-swatch"
            ),
            o = 0;
          o < s.length;
          o++
        )
          for (
            var r = s[o].attributes.data_sel_val.value, c = 0;
            c < e.length;
            c++
          )
            e[c] == r
              ? (s[o].className += "  var_sel_stone  ")
              : (s[o].className += "  var_desel_stone  ");
      }),
      // $(".comp_label input[type=checkbox]:checked").prop("checked", !1),
      // $(".comp_label .checkmark").addClass("remove_check"),
      $(".toggle-view li").click(function () {
        var t = $(this).children("div.panel");
        t.is(":hidden")
          ? (t.slideDown("200"),
            $(this).children("span").html('<i class="icofont-thin-up"></i>'))
          : (t.slideUp("200"),
            $(this).children("span").html('<i class="icofont-thin-down"></i>'));
      });
    var a = $(".NS_wrapper.rev_iew_cl")
      .find("#judgeme_product_reviews")
      .attr("style");
    void 0 !== a &&
      a.includes("none") &&
      $(".NS_wrapper.rev_iew_cl").css("min-height", "30px"),
      $("#custom-numbers li.clickable").click(function () {
        $("#custom-numbers li").removeClass("active"),
          $(this).addClass("active");
        var t = $(this).find("input").val();
        console.log(t),
          $(this)
            .parents(".main_product_fu")
            .find(".product-single__variants")
            .val(t)
            .trigger("change");
      }),
      // $(".gift_note_pro").keyup(function () {
      //   $(this).val().length > 0
      //     ? $(this).attr("name", "properties[Card Note]")
      //     : $(this).removeAttr("name", "properties[Card Note]");
      // }),
      "Womens Gift Box" ==
        $(".custom-swatch-selection .swatch_inner").attr("data-vendor") &&
        $(this).parent(".custom-swatch-selection").css("display", "none"),
      $(".custom-swatch").click(function () {
        var t = $(this).find("input").val(),
          a = $(this).find("input").attr("data-url"),
          e = $(this).find("input").attr("data-soldout"),
          i = $(this).find("input").attr("data-title");
        $(this)
          .parents(".ProductItem")
          .find(".custom-swatch")
          .removeClass("is-active"),
          $(this)
            .parents(".ProductItem")
            .find(".product-card__media img")
            .attr("src", t),
          $(this)
            .parents(".ProductItem")
            .find(".product-card__media img")
            .attr("srcset", t),
          " " === e
            ? $(this).parents(".ProductItem").find(".custom_newred").remove()
            : $(this)
                .parents(".ProductItem")
                .find(".ProductItem__Info .custom_blank_wrapper")
                .empty()
                .append(
                  '<span class="custom_newred"><ly-as-250000>' +
                    e +
                    "</ly-as-250000></span>"
                ),
          $(this).addClass("is-active"),
          $(this)
            .parents(".ProductItem")
            .find(".product-card__media")
            .attr("href", a),
          $(this)
            .parents(".ProductItem")
            .find(".product-title.h6")
            .attr("href", a),
          $(this).parents(".ProductItem").find(".product-title.h6").text(i);
      });
  });
// 28/12

// $(document).ready(function () {
// 	$('#prod_img').zoom({
// 		on: 'click'
// 	});
// 	$(document).on("click", ".product-thumsDesktop div", function () {
// 		var url = $(this).find("img").attr('data-zoomImage'),
// 			activeImage = $('#prod_img > img');
// 		$('.product-thumsDesktop div').removeClass('active');
// 		$(this).parent('div').addClass('active');
// 		activeImage.attr('src', url);
// 	});
// });


$(".gift_note_pro").val("");
$(".comp_checkbox .comp_label").click(function(){
$('.comp_checkbox.gift_che').find('#gift_box').attr('value' , '' );
  $('.comp_checkbox').addClass("gift_che");
    $(".comp_checkbox .box_gift").removeClass("gift_check");
    $(".comp_checkbox input[type='checkbox']").not($(this).find("input[type='checkbox']")).prop("checked",false);
   $(".comp_checkbox input[type='checkbox']").not($(this).find("input[type='checkbox']")).removeClass("gift_che");
   // $(".comp_checkbox input[type='checkbox']").not($(this).find("input[type='checkbox']")).(".box_gift").removeClass("gift_check");;
       
  if($(this).find("input[type='checkbox']").prop("checked") == false){
        $(this).find("input[type='checkbox']").prop("checked",true);
     $(this).find(".checkmark").removeClass("remove_check");
     $(".gift_note_pro").slideDown();
      $('.comp_checkbox').addClass("gift_che");
    $(this).parents(".box_gift").addClass("gift_check");
    var gift_box = $(this).find('.limited_edition').text();
    $('.comp_checkbox.gift_che').find('#gift_box').attr('name' , 'properties[Gift Wrapping Type]' );
    $('.comp_checkbox.gift_che').find('#gift_box').attr('value' , gift_box );
  }
    else{
        $(this).find("input[type='checkbox']").prop("checked",false);
       $(this).find(".checkmark").addClass("remove_check");
      $(".gift_note_pro").slideUp();
      	$(".gift_note_pro").val("");
        $('.comp_checkbox').removeClass("gift_che");
        $(this).parents(".box_gift").removeClass("gift_check");
    }

  if( $(".gift_note_pro").val().length < 0){  }else{    $(".gift_note_pro").removeAttr("name","properties[Cart Note]");  }

});
$('.gift_note_pro').keyup(function() {

  var characterCount = $(this).val().length;
  if(characterCount > 0){
    $('.comp_checkbox_wrap').addClass("gift_che_add");
    $(this).attr("name","properties[Card Note]");
  }else
  {
      $('.comp_checkbox_wrap').removeClass("gift_che_add");
    $(this).removeAttr("name","properties[Card Note]");
  }

});
// $( document ).ready(function() {
//   $('.comp_label input[type=checkbox]:checked').prop('checked', false);
//   $(".comp_label .checkmark").addClass("remove_check");
// });


$(document).on("click", '.v-stack .buy-buttons .button', function (e) {
 // debugger;
e.preventDefault();
$(this).addClass('is-loading');
$(this).find('span').find('svg').css("display", "unset");
$(this).find("span.hi_fade").css("display", "none");
  
var count_new = 0;
var subtotal_new =0; 
var get_variant_id = parseInt($(this).attr("variant_id"));
var product_id = $(this).attr("product_id"); 
var prod_up = $(this).parents('.product-section').find('#product_upsell').val();
var product_sku = $(this).attr('product_sku');
var items = [];   
var properties_data = [];  
var gift_wrap = $('.comp_checkbox.gift_che .box_gift.gift_check').find('.comp_label input[type="checkbox"]').val();
var gift_prop =  $('.comp_checkbox.gift_che').find('#gift_box').val();
var cart_note = $('.comp_checkbox_wrap.gift_che_add').find('.gift_note_pro').val();
$('.secondStrapSlider .item input[type="checkbox"]:checked').each(function (i, e) {        
var variantid = parseInt($(this).val()); 
items.push({id: variantid,quantity: 1,properties: { "Product Upsell":  product_sku, "Gift Wrapping" : gift_wrap,"Gift Wrapping Type" : gift_prop,"Card Note" : cart_note } });  
properties_data.push(variantid);
});    
var main = {id: get_variant_id,quantity: 1,properties: { "Gift Wrapping" : gift_wrap,"Gift Wrapping Type" : gift_prop,"Card Note" : cart_note }  }       
items.push(main);
var data_stri = JSON.stringify(items);
if (items.length > 0) {
  
var prod_up = data_stri.trim();
var formData_cust = new FormData();
var formData_cust = { 'items': items };
fetch(window.Shopify.routes.root + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json' },
body: JSON.stringify(formData_cust)
})
.then((resp) => {
return resp.json();
})
.then((data) => {
document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
bubbles: true
}));


setTimeout(()=>{
$.getJSON('/cart.json').then(cart => {
fetch('/?section_id=cart-drawer').then(d=>d.text()).then(text=>{
var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
// console.log('sectionInnerHTML',sectionInnerHTML)
var cartFormInnerHTML = sectionInnerHTML.getElementById('cart-drawer').innerHTML;
// console.log('cartFormInnerHTML',cartFormInnerHTML)
$('#cart-drawer').html(cartFormInnerHTML)
$('[aria-controls="cart-drawer"]')[0].click()
var cart_item_count = cart.item_count
$('.cart_drawer_ou .Header__CartCount').empty().append(cart_item_count);
$(".buy-buttons .button").removeClass('is-loading');
if(cart_item_count >= 15) {
  $('.cart_limit_msg').removeClass('master');
}
});
});
},500);
})
.catch((error) => {
console.error('Error:', error);
});

}

setTimeout(function(){
$(".buy-buttons .button").find('span').find('svg').css("display", "none");
$('buy-buttons .button').find(".buttonText").find("span.hi_fade").fadeIn();
}, 600);
});


// promo code
$(document).ready(function(){
    
  $(document).on("click","#redemDevPromo",function(event){  
   event.preventDefault();
   if($('#devPromo').val() != ""){
     $('.coupon-missing-error').hide();
     $('#devPromo_new').val($('#devPromo').val());
     $('.disc_promo').show();
     $('#devPromo').attr("disabled", "disabled");
     $('.cart_loader').show();
     $('.disc_promo').hide();
     $('#redemDevPromo').addClass('active');

     setTimeout(function(){   
       $('.disc_promo').show();
       $('.cart_loader').hide();
       $('#devPromo').css("text-indent", "-270px");
       $('.promo_hide').hide();
       $('#redemDevPromo').removeClass('active');
     }, 1500); 

   }else{
     $('.coupon-missing-error').show();

   }

 });
 var input = document.getElementById("devPromo"); 
 input.addEventListener("keyup", function(event) { 
   if (event.keyCode === 13) {
     event.preventDefault();
     event.stopPropagation();
     document.getElementById("redemDevPromo").click();
   }
 });


$(document).on("click",".code_remove , #redemDevPromo_remove",function(event){    
   event.preventDefault();
   $('.disc_promo').hide();
   $('#devPromo').val('');     
   $('#redemDevPromo').removeAttr("disabled"); 
   $('#redemDevPromo').css("display", "block");
   $('#devPromo').removeAttr("disabled");  
   $('#devPromo').css("text-indent", "0px");
   $('#redemDevPromo_remove').css("display", "none");
   $('.promo_hide').show();
 }); 


$(document).on('click','.cart-promo h2',function(){
$(this).siblings('.promo_box').slideToggle();
$(this).toggleClass("active");
})




function calculateAndUpdateHeight() {
  if($(window).width() <= 767){
      var height; // Initialize a variable to store the height

      $('.secondStrap .secondStrapImg').each(function() {
          height = $(this).height(); // Update the height variable with the height of the current element
          return false; // Exit the loop after the first iteration
      });

      // Get the margin-top of .secondStrap
      var secondStrapMarginTop = parseInt($('.secondStrap').css('margin-top'));

      // Calculate the sum
      var totalHeight = height / 2;
      var topArraow = (totalHeight + secondStrapMarginTop) - 20;
      console.log(topArraow);
      $('.secondStrapSlider .owl-next,.secondStrapSlider .owl-prev').css('top', topArraow + 'px');
  }
}

// Run the function on window load
$(window).on('load', calculateAndUpdateHeight);

// Run the function on window resize, with a debounce of 200ms
var resizeTimer;
$(window).on('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(function() {
      calculateAndUpdateHeight();
  }, 200);
});

  
});


$(document).ready(function(){

$('.cart_drawer_ou .Header__CartCount').on('DOMSubtreeModified', function(){
  $.getJSON('/cart.json').then(cart => {
// alert(JSON.stringify(cart.total_price));
    // debugger;
$.ajax({
                url: '/?section_id=cart-drawer',
                type: 'GET',
                dataType: 'html',
                success:function(carthtml) {
                  $('cart-drawer').html($(carthtml).find('cart-drawer').html());
                }
              });
});
});

// Shopify.updateCartAttributes = function(data, callback) {
//   alert("aaa");
//   var params = {
//     type: 'POST',
//     url: '/cart/update.js',
//     data: data,
//     dataType: 'json',
//     success: function(cart) {
//       if ((typeof callback) === 'function') {
//         callback(cart);
//       }
//       else {
//         Shopify.onCartUpdate(cart);
//       }
//     },
//     error: function(XMLHttpRequest, textStatus) {
//       Shopify.onError(XMLHttpRequest, textStatus);
//     }
//   };
//   jQuery.ajax(params);
// }; 

//     Shopify.onCartUpdate = function(cart) {
//   alert('There are now ' + cart.item_count + ' items in the cart.');
// };
  
// $.getJSON('/cart.json').then(cart => {
// // alert("aaaa");
// fetch('/?section_id=cart-drawer').then(d=>d.text()).then(text=>{
// var sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
// // console.log('sectionInnerHTML',sectionInnerHTML)
// var cartFormInnerHTML = sectionInnerHTML.getElementById('cart-drawer').innerHTML;
// // console.log('cartFormInnerHTML',cartFormInnerHTML)
// $('#cart-drawer').html(cartFormInnerHTML);
// var cart_item_count = cart.item_count
// $('.cart_drawer_ou .Header__CartCount').empty().append(cart_item_count);
// $(".buy-buttons .button").removeClass('is-loading');
// if(cart_item_count >= 15) {
//   $('.cart_limit_msg').removeClass('master');
// }
// });
// });
});